import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const AgentRewardContext = createContext();

export const AgentRewardProvider = ({ children }) => {
  const [agentRewards, setAgentRewards] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: LIMIT_DATA_PER_PAGE,
    // tambahkan include jika diperlukan
    include: "agent,season",
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchAgentRewards = useCallback(async () => {
    setAgentRewards((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/agent-reward${queryString}`);
      if (response.success) {
        setAgentRewards({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setAgentRewards({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchAgentRewards();
  }, [fetchAgentRewards]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = agentRewards.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5,
  });

  return (
    <AgentRewardContext.Provider
      value={{
        agentRewards,
        filterOptions,
        handleSearch,
        refetch: fetchAgentRewards,
        Pagination,
      }}
    >
      {children}
    </AgentRewardContext.Provider>
  );
};

export const useAgentReward = () => {
  const context = useContext(AgentRewardContext);
  if (!context) {
    throw new Error("useAgentReward must be used within AgentRewardProvider");
  }

  const fetchOptions = async (inputValue) => {
    const response = await getRequest(`/agent-reward?search=${inputValue}`);
    if (response.success) {
      return response.data.map((reward) => ({
        value: reward.id,
        label: `${reward.agent?.name || "Unknown Agent"} - ${reward.reward}`,
      }));
    }
    return [];
  };

  return { ...context, fetchOptions };
};
